import type {
  PreparePaabudIndberetningRequest,
  PreparePaabudIndberetningResponse,
} from "@/interfaces/paabudIndberetning";
import type { PendingEvidenceResponse } from "@/interfaces/indberetning";
import type { ReportEvidenceModel } from "@cle/models/reportEvidence";
import { ApiRequestError, getWithErrorObject, post } from "./util";

const PAABUD_INDBERETNING_QUERY = "Paabud/indberetning";

export const PAABUD_INDBERETNING_QUERY_KEY = [
  "paabud",
  "indberetning",
] as const;

export const createPaabudEvidenceQueryKey = (paabudId: string) =>
  [...PAABUD_INDBERETNING_QUERY_KEY, "paabud", paabudId, "evidence"] as const;

export const createPaabudPendingEvidenceQueryKey = (indberetningId: string) =>
  [
    ...PAABUD_INDBERETNING_QUERY_KEY,
    "pending-evidence",
    indberetningId,
  ] as const;

export const getPendingPaabudIndberetningEvidence = async (
  indberetningId: string,
): Promise<PendingEvidenceResponse> => {
  try {
    return await getWithErrorObject<PendingEvidenceResponse>({
      query: `${PAABUD_INDBERETNING_QUERY}/${indberetningId}/pending-evidence`,
    });
  } catch (error) {
    if (error instanceof ApiRequestError && error.status === 404) {
      return { evidenceItemIds: [] };
    }

    throw error;
  }
};

export const preparePaabudIndberetningForSigning = (
  request: PreparePaabudIndberetningRequest,
): Promise<PreparePaabudIndberetningResponse> =>
  post<PreparePaabudIndberetningResponse>({
    query: `${PAABUD_INDBERETNING_QUERY}/prepare-for-signing`,
    body: request,
  });

export const getReportEvidenceByPaabud = async (
  paabudId: string,
): Promise<ReportEvidenceModel[]> => {
  try {
    return await getWithErrorObject<ReportEvidenceModel[]>({
      query: `${PAABUD_INDBERETNING_QUERY}/paabud/${paabudId}/evidence`,
    });
  } catch (error) {
    if (error instanceof ApiRequestError && error.status === 404) {
      return [];
    }

    throw error;
  }
};
